import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PortalManager } from 'igniteui-angular-core';
import { AppComponent } from './app.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
const routes: Routes = [
  { path: '', component: ResetPasswordComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
